var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenes__items"},[(_vm.isLoading)?_c('Loading'):_c('SceneBoxes',{attrs:{"scenes":_vm.scenes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }